import React from "react";
import { CheckBox, TextBox } from "devextreme-react";
import { useSelector } from "react-redux";
import { selectContract } from "../../../redux/contract/selectors";

function SendMailSmsForm(props){

    const { classes, dataSms, onValueChange } = props;
    const contract = useSelector(selectContract);
    const originalEmail = contract.contractData?.email? contract.contractData.email : "";

    function onValueChangeSendMail(value){
        onValueChange("email", originalEmail);
        onValueChange("sendMail", value);
    }

    return (
            <div style={{display: "grid", gridTemplateColumns: "repeat(2, 1fr)", columnGap: "1rem", height: "3rem"}}>
                <div style={{display: "flex", alignItems: "center", columnGap: "0.5rem"}}>
                    <CheckBox id="send-email-check" value={dataSms.sendMail} onValueChanged={(e) => onValueChangeSendMail(e.value)} className={classes.controlers} style={{marginTop: 0}}></CheckBox>
                    <label to={"send-email-check"}>Enviar email</label>
                </div>
                {dataSms.sendMail &&
                    <TextBox label="Enviar email" labelMode="floating" key={"email"} name="email" value={dataSms.email} onValueChanged={(e) => onValueChange("email", e.value)} className={classes.controlers} />
              }
            </div>
    )
}

export default SendMailSmsForm;